<template>
  <div
    v-if="categories"
    class="hide-scrollbar flex w-full gap-2 overflow-x-auto overflow-y-hidden"
    :class="{ 'animate-pulse': fetching }"
  >
    <nuxt-link
      v-for="category in visibleCategories"
      :key="category.id"
      :to="linkCategoryTo(category)"
      class="flex flex-nowrap items-center justify-center whitespace-nowrap border px-3 py-2 text-base font-bold"
    >
      {{ category.name }}
    </nuxt-link>
  </div>
</template>

<script setup lang="ts">
import type { Category } from '@scayle/storefront-nuxt'

const props = defineProps({
  categories: {
    type: Array as PropType<Category[]>,
    default: () => [],
  },
  fetching: {
    type: Boolean,
    required: true,
  },
})

const visibleCategories = computed(() =>
  props.categories?.filter((c) => !isHiddenForPLPNavigation(c)),
)
</script>

<style scoped>
.hide-scrollbar {
  scrollbar-width: none;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}
.hide-scrollbar::-webkit-scrollbar {
  width: 0 !important;
  display: none !important;
}
</style>
